export default __webpack_public_path__ + "static/media/โปรที่5BT86.a4d530bb.png";